import { itemThumbnailUrl } from "./itemThumbnailUrls";

export type ItemTemplate = {
  nameKey: string;
  intervalDays: number;
  categoryKey: string;
  iconUrl: string;
};

type ItemTemplateDefinition = Omit<ItemTemplate, "iconUrl">;

const templateDefinitions: ItemTemplateDefinition[] = [
  // バス・洗面
  {
    nameKey: "templates:items.shampoo",
    intervalDays: 30,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.conditioner",
    intervalDays: 30,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.bodySoap",
    intervalDays: 30,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.faceWash",
    intervalDays: 45,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.toner",
    intervalDays: 60,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.moisturizer",
    intervalDays: 60,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.sunscreen",
    intervalDays: 90,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.cottonSwabs",
    intervalDays: 60,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.toothbrush",
    intervalDays: 90,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.toothpaste",
    intervalDays: 60,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.razorBlade",
    intervalDays: 30,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.toiletPaper",
    intervalDays: 14,
    categoryKey: "templates:categories.bath",
  },
  {
    nameKey: "templates:items.tissue",
    intervalDays: 21,
    categoryKey: "templates:categories.bath",
  },

  // キッチン
  {
    nameKey: "templates:items.dishSoap",
    intervalDays: 30,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.sponge",
    intervalDays: 30,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.trashBag",
    intervalDays: 30,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.plasticWrap",
    intervalDays: 45,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.kitchenPaper",
    intervalDays: 21,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.handSoap",
    intervalDays: 30,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.dishwasherDetergent",
    intervalDays: 30,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.drainNet",
    intervalDays: 30,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.aluminumFoil",
    intervalDays: 60,
    categoryKey: "templates:categories.kitchen",
  },
  {
    nameKey: "templates:items.cookingSheet",
    intervalDays: 60,
    categoryKey: "templates:categories.kitchen",
  },

  // 洗濯
  {
    nameKey: "templates:items.laundryDetergent",
    intervalDays: 30,
    categoryKey: "templates:categories.laundry",
  },
  {
    nameKey: "templates:items.fabricSoftener",
    intervalDays: 30,
    categoryKey: "templates:categories.laundry",
  },
  {
    nameKey: "templates:items.bleach",
    intervalDays: 60,
    categoryKey: "templates:categories.laundry",
  },
  {
    nameKey: "templates:items.washingMachineCleaner",
    intervalDays: 90,
    categoryKey: "templates:categories.laundry",
  },
  {
    nameKey: "templates:items.laundryNet",
    intervalDays: 180,
    categoryKey: "templates:categories.laundry",
  },

  // 掃除
  {
    nameKey: "templates:items.toiletCleaner",
    intervalDays: 30,
    categoryKey: "templates:categories.cleaning",
  },
  {
    nameKey: "templates:items.floorCleaner",
    intervalDays: 60,
    categoryKey: "templates:categories.cleaning",
  },
  {
    nameKey: "templates:items.glassCleaner",
    intervalDays: 60,
    categoryKey: "templates:categories.cleaning",
  },
  {
    nameKey: "templates:items.lintRollerRefill",
    intervalDays: 30,
    categoryKey: "templates:categories.cleaning",
  },
  {
    nameKey: "templates:items.sanitizingWipes",
    intervalDays: 30,
    categoryKey: "templates:categories.cleaning",
  },
  {
    nameKey: "templates:items.disposableGloves",
    intervalDays: 60,
    categoryKey: "templates:categories.cleaning",
  },

  // 医薬・衛生
  {
    nameKey: "templates:items.mask",
    intervalDays: 30,
    categoryKey: "templates:categories.medical",
  },
  {
    nameKey: "templates:items.disinfectant",
    intervalDays: 60,
    categoryKey: "templates:categories.medical",
  },
  {
    nameKey: "templates:items.bandage",
    intervalDays: 180,
    categoryKey: "templates:categories.medical",
  },
  {
    nameKey: "templates:items.medicine",
    intervalDays: 180,
    categoryKey: "templates:categories.medical",
  },
  {
    nameKey: "templates:items.eyeDrops",
    intervalDays: 90,
    categoryKey: "templates:categories.medical",
  },

  // ベビー
  {
    nameKey: "templates:items.diaper",
    intervalDays: 7,
    categoryKey: "templates:categories.baby",
  },
  {
    nameKey: "templates:items.babyWipes",
    intervalDays: 14,
    categoryKey: "templates:categories.baby",
  },
  {
    nameKey: "templates:items.babyDetergent",
    intervalDays: 30,
    categoryKey: "templates:categories.baby",
  },

  // 文具・事務
  {
    nameKey: "templates:items.penRefill",
    intervalDays: 180,
    categoryKey: "templates:categories.stationery",
  },
  {
    nameKey: "templates:items.stickyNotes",
    intervalDays: 90,
    categoryKey: "templates:categories.stationery",
  },
  {
    nameKey: "templates:items.copyPaper",
    intervalDays: 180,
    categoryKey: "templates:categories.stationery",
  },
  {
    nameKey: "templates:items.inkCartridge",
    intervalDays: 120,
    categoryKey: "templates:categories.stationery",
  },

  // 防災
  {
    nameKey: "templates:items.emergencyWater",
    intervalDays: 365,
    categoryKey: "templates:categories.disaster",
  },
  {
    nameKey: "templates:items.emergencyFood",
    intervalDays: 365,
    categoryKey: "templates:categories.disaster",
  },
  {
    nameKey: "templates:items.cassetteGas",
    intervalDays: 180,
    categoryKey: "templates:categories.disaster",
  },

  // 車・アウトドア
  {
    nameKey: "templates:items.wiperBlade",
    intervalDays: 365,
    categoryKey: "templates:categories.vehicle",
  },
  {
    nameKey: "templates:items.engineOil",
    intervalDays: 365,
    categoryKey: "templates:categories.vehicle",
  },
  {
    nameKey: "templates:items.insectRepellent",
    intervalDays: 90,
    categoryKey: "templates:categories.vehicle",
  },

  // その他
  {
    nameKey: "templates:items.contactLens",
    intervalDays: 30,
    categoryKey: "templates:categories.other",
  },
  {
    nameKey: "templates:items.battery",
    intervalDays: 90,
    categoryKey: "templates:categories.other",
  },
  {
    nameKey: "templates:items.petFood",
    intervalDays: 14,
    categoryKey: "templates:categories.other",
  },
  {
    nameKey: "templates:items.catLitter",
    intervalDays: 14,
    categoryKey: "templates:categories.other",
  },
  {
    nameKey: "templates:items.petSheet",
    intervalDays: 14,
    categoryKey: "templates:categories.other",
  },
];

const allTemplates: ItemTemplate[] = templateDefinitions.map((template) => ({
  ...template,
  iconUrl: itemThumbnailUrl(template.nameKey.split(".").at(-1) ?? "other"),
}));

const excludedTemplateKeys = new Set([
  "templates:items.cottonSwabs",
  "templates:items.razorBlade",
  "templates:items.laundryNet",
  "templates:items.disposableGloves",
  "templates:items.babyDetergent",
  "templates:items.inkCartridge",
  "templates:items.emergencyWater",
  "templates:items.emergencyFood",
  "templates:items.cassetteGas",
  "templates:items.wiperBlade",
  "templates:items.engineOil",
  "templates:items.insectRepellent",
  "templates:items.petSheet",
  "templates:items.catLitter",
]);

export const templates = allTemplates.filter(
  (template) => !excludedTemplateKeys.has(template.nameKey),
);

export function getCategories(): string[] {
  return [...new Set(templates.map((t) => t.categoryKey))];
}

export function getTemplatesByCategory(categoryKey: string): ItemTemplate[] {
  return templates.filter((t) => t.categoryKey === categoryKey);
}
